import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import FacebookPagesAPI from '../../api/facebookPages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getPosts($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { pageId, params }) => {
    commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, true);
    try {
      const response = await FacebookPagesAPI.getPosts(pageId, params);
      commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, false);
      commit(types.default.SET_FACEBOOK_PAGE_POSTS, response.data);
    } catch (error) {
      commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, false);
    }
  },
  getFolderPosts: async ({ commit }, { pageIds, params }) => {
    commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, true);
    try {
      const responses = await Promise.all(
        pageIds.map(pageId => FacebookPagesAPI.getPosts(pageId, params))
      );

      const combinedData = {
        facebook: {
          posts: [],
          currentPage: params.pagination.facebook.currentPage,
          totalCount: 0,
          totalPages: 0,
          perPage: params.pagination.facebook.perPage,
        },
        instagram: {
          posts: [],
          currentPage: params.pagination.instagram.currentPage,
          totalCount: 0,
          totalPages: 0,
          perPage: params.pagination.instagram.perPage,
        },
      };

      responses.forEach(response => {
        const data = response.data;
        if (data.facebook) {
          combinedData.facebook.posts.push(...(data.facebook.posts || []));
          combinedData.facebook.totalCount += data.facebook.totalCount || 0;
        }
        if (data.instagram) {
          combinedData.instagram.posts.push(...(data.instagram.posts || []));
          combinedData.instagram.totalCount += data.instagram.totalCount || 0;
        }
      });

      const sortByDate = (a, b) =>
        new Date(b.created_at) - new Date(a.created_at);
      combinedData.facebook.posts.sort(sortByDate);
      combinedData.instagram.posts.sort(sortByDate);

      combinedData.facebook.totalPages = Math.ceil(
        combinedData.facebook.totalCount / combinedData.facebook.perPage
      );
      combinedData.instagram.totalPages = Math.ceil(
        combinedData.instagram.totalCount / combinedData.instagram.perPage
      );

      commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, false);
      commit(types.default.SET_FACEBOOK_PAGE_POSTS, combinedData);
    } catch (error) {
      commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, false);
    }
  },
  toggleActive: async ({ commit }, { pageId, postId }) => {
    try {
      await FacebookPagesAPI.toggleActive(pageId, postId);
    } catch (error) {
      commit(types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS, false);
    }
  },

  deletePost: async ({ state: vuexState, commit }, { pageId, postId }) => {
    await FacebookPagesAPI.deletePost(pageId, postId);
    const records = vuexState.records || {};
    const next = {};
    ['facebook', 'instagram'].forEach(platform => {
      if (!records[platform]) {
        next[platform] = records[platform];
        return;
      }
      const prevPosts = records[platform].posts || [];
      const posts = prevPosts.filter(p => p.id !== postId);
      const removed = prevPosts.length - posts.length;
      next[platform] = {
        ...records[platform],
        posts,
        totalCount: Math.max(0, (records[platform].totalCount || 0) - removed),
      };
    });
    commit(types.default.SET_FACEBOOK_PAGE_POSTS, next);
  },
};

export const mutations = {
  [types.default.SET_FACEBOOK_PAGE_POSTS_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_FACEBOOK_PAGE_POSTS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
